import ProfileHeader from '@/pages/views/ProfileHeader';
import { QueryClient, QueryClientProvider } from 'react-query';
import React from 'react';
import ReactQueryProvider from '@/API/ReactQueryProvider';

const ProfileHeaderComponent = ({ logo }) => {
  const queryClient = new QueryClient();
  return (
    <ReactQueryProvider>
      <ProfileHeader logo={logo} />
    </ReactQueryProvider>
  );
};
export default ProfileHeaderComponent;
